import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { featureKey } from './selectors';
import { featureReducer } from './reducer';
import { FeatureEffects } from './effects';
import { ShippingAddressEffects } from './shipping-address-effects';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, featureReducer),
    EffectsModule.forFeature([FeatureEffects, ShippingAddressEffects]),
  ],
})
export class OrganizationsStoreModule {}
